import {ImportingDataTypes} from "../../types";
import {PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.externalVendors,
    sections: [
        {
            sectionKey: 'missingVendorCode',
            sectionTitle: 'Missing Vendor Code',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [{
                key: 'code',
                label: 'Vendor Code',
                type: 'input',
                modifyRow: (row, val) => ({...row, code: val}),
            }],
        },
    ],
};
